<template>
  <!--
    	作者：kmdshop
    	时间：2019-10-26
    	描述：商品管理-商品编辑-规格/库存-单规格
       修改：增加加价金额功能
  -->
  <div>
    <el-form-item label="产品价格：" width="80" :rules="[{ required: true, message: '请填写产品价格' }]" 
    prop="model.sku.product_price">
    <span v-if="type == 'edit'">
        <el-input type="number" :disabled="form.supplySetting.is_supply&&form.supplySetting.product_price_edit!=1" 
      v-model="form.model.sku.product_price" class="max-w460"></el-input>
      </span>
      <span v-if="type == 'add'">
        <el-input type="number"  v-model="form.model.sku.product_price" class="max-w460"></el-input>
      </span>
    
    </el-form-item>
    <el-form-item :label="form.supply_price_name+'：'"  width="80"  prop="model.sku.product_supply_price">
    
      <span v-if="type == 'edit'">
        <el-input type="number"  :disabled="form.supplySetting.is_supply&&form.supplySetting.product_price_edit!=1" 
        v-model="form.model.sku.product_supply_price" class="max-w460"></el-input>
      
      </span>
      <span v-if="type == 'add'">
        <el-input type="number"  v-model="form.model.sku.product_supply_price" class="max-w460"></el-input>
      </span>
    </el-form-item>

    <!-- ========= 新增：加价金额功能 ========= -->
    <el-form-item label="加价金额：" prop="model.sku.is_add">
      <el-switch
        v-model="form.model.sku.is_add"
        :active-value="1"
        :inactive-value="0"
        active-text="开启"
        inactive-text="关闭">
      </el-switch>
      <span class="tip-text">开启后，可设置额外加价金额</span>
    </el-form-item>

    <el-form-item 
  label="加价金额(元)：" 
  prop="model.sku.add_price"
  v-if="form.model.sku.is_add === 1"
  :rules="[
    { required: true, message: '请填写加价金额' },
    { 
      validator: (rule, value, callback) => {
        if (value === '' || value === null || value === undefined) {
          callback(new Error('请填写加价金额'));
        } else {
          const num = Number(value);
          if (isNaN(num)) {
            callback(new Error('请输入有效的数字'));
          } else if (num < 0) {
            callback(new Error('加价金额不能小于0'));
          } else {
            callback();
          }
        }
      }, 
      trigger: 'blur' 
    }
  ]"
>
      <el-input 
        type="number" 
        v-model="form.model.sku.add_price" 
        class="max-w460" 
        placeholder="请输入加价金额，例如：10.00">
        <template slot="append">元</template>
      </el-input>
    </el-form-item>

    <el-alert
      v-if="form.model.sku.is_add === 1 && form.model.sku.product_price && form.model.sku.add_price"
      :title="`最终结算价：${ (Number(form.model.sku.product_price) + Number(form.model.sku.add_price)).toFixed(2) } 元`"
      type="info"
      :closable="false"
      style="margin-top: 8px;">
    </el-alert>
    <!-- ========= 新增结束 ========= -->

    <el-form-item label="产品划线价："  prop="model.sku.line_price">
      <el-input type="number" v-model="form.model.sku.line_price" class="max-w460"></el-input>
     </el-form-item>
    <el-form-item label="库存数量：" :rules="[{ required: true, message: '请填写库存数量' }]" prop="model.sku.stock_num">
      <el-input type="number" v-model="form.model.sku.stock_num" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="商品重量(Kg)：" prop="model.sku.product_weight">
      <el-input type="number" v-model="form.model.sku.product_weight" class="max-w460"></el-input>
    </el-form-item>
  </div> 
</template>

<script>
  export default{
    props:['type'],
    inject: ["form"],
    // 可选：在组件挂载时，确保 form.model.sku 对象中有 is_add 和 add_price 的默认值
    mounted() {
      if (this.form.model.sku) {
        // 确保字段存在，防止未定义导致 v-model 出错
        if (this.form.model.sku.is_add === undefined) {
          this.$set(this.form.model.sku, 'is_add', 0) // 默认关闭
        }
        if (this.form.model.sku.add_price === undefined) {
          this.$set(this.form.model.sku, 'add_price', 0) // 默认加价金额为0
        }
      }
    }
  }
</script>

<style scoped>
.tip-text {
  margin-left: 10px;
  font-size: 12px;
  color: #909399;
}
</style>


// WEBPACK FOOTER //
// src/views/product/product/part/spec/Single.vue